module.exports = __webpack_public_path__ + "static/img/coe-4ton-blue.b9bd470.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-blue.svg
// module id = z6ny
// module chunks = 82